module.exports = __webpack_public_path__ + "static/6-466e7d2e82bcdc25368b811a1661da47.jpeg";